import { render, staticRenderFns } from "./ReporteCobranza.vue?vue&type=template&id=34408071&scoped=true"
import script from "./ReporteCobranza.vue?vue&type=script&lang=js"
export * from "./ReporteCobranza.vue?vue&type=script&lang=js"
import style0 from "./ReporteCobranza.vue?vue&type=style&index=0&id=34408071&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34408071",
  null
  
)

export default component.exports